// FAQ accordion
document.querySelectorAll('.faq__q').forEach(function (btn) {
  btn.addEventListener('click', function () {
    btn.parentElement.classList.toggle('open');
  });
});

// Sticky add-to-cart visibility after scroll past hero
var sticky = document.getElementById('stickyBuy');
var hero = document.querySelector('.hero');
if (hero && sticky) {
  window.addEventListener('scroll', function () {
    var past = window.scrollY > hero.offsetHeight * 0.6;
    sticky.classList.toggle('visible', past);
  });
}

// Countdown timer (cosmetic)
var cdEl = document.getElementById('cd-h');
if (cdEl) {
  var total = 2 * 3600 + 14 * 60 + 33;
  setInterval(function () {
    total = Math.max(0, total - 1);
    var h = String(Math.floor(total / 3600)).padStart(2, '0');
    var m = String(Math.floor((total % 3600) / 60)).padStart(2, '0');
    var s = String(total % 60).padStart(2, '0');
    cdEl.textContent = h + ':' + m + ':' + s;
  }, 1000);
}

// Smooth scroll for in-page links
document.querySelectorAll('a[href^="#"]').forEach(function (a) {
  a.addEventListener('click', function (e) {
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// Hero click-to-play YouTube (TVC, etc.)
document.querySelectorAll('.hero__video').forEach(function (wrap) {
  wrap.addEventListener('click', function () {
    if (wrap.classList.contains('is-playing')) return;
    var id = wrap.getAttribute('data-video-id');
    var title = wrap.getAttribute('data-video-title') || 'Hero video';
    if (!id) return;
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id)
      + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    iframe.title = title;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    wrap.appendChild(iframe);
    wrap.classList.add('is-playing');
  });
});

// MWC click-to-play YouTube (TV interview, etc.)
document.querySelectorAll('.mwc-hero__video').forEach(function (wrap) {
  wrap.addEventListener('click', function () {
    if (wrap.classList.contains('is-playing')) return;
    var id = wrap.getAttribute('data-video-id');
    var title = wrap.getAttribute('data-video-title') || 'MWC interview';
    if (!id) return;
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id)
      + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    iframe.title = title;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    wrap.appendChild(iframe);
    wrap.classList.add('is-playing');
  });
});
